import React from "react";

export const AttachmentsEmptyState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="relative mb-3 flex h-28 w-28 items-center justify-center">
        {/* Soft radial backdrop */}
        <div className="absolute inset-x-2 bottom-0 h-10 rounded-full bg-purple-100/60 blur-sm" />
        
        {/* Document illustration */}
        <svg
          width="96"
          height="88"
          viewBox="0 0 96 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="relative z-10 drop-shadow-sm"
        >
          {/* Back document */}
          <rect
            x="32"
            y="10"
            width="42"
            height="56"
            rx="5"
            transform="rotate(6 32 10)"
            fill="#F3E8FF"
            stroke="#E9D5FF"
            strokeWidth="1.5"
          />
          {/* Line details on back doc */}
          <path
            d="M40 24L64 27M41 32L65 35M42 40L58 42"
            stroke="#C084FC"
            strokeWidth="1.5"
            strokeLinecap="round"
          />

          {/* Front purple folder/document */}
          <rect
            x="20"
            y="18"
            width="44"
            height="58"
            rx="6"
            transform="rotate(-8 20 18)"
            fill="url(#frontDocGrad)"
            stroke="#7C3AED"
            strokeWidth="1.5"
          />

          {/* Paperclip */}
          <path
            d="M42 12C42 8.5 44.5 6 47.5 6C50.5 6 53 8.5 53 12V32C53 36 50 38.5 46.5 38.5C43 38.5 40 36 40 32V14C40 12 41.5 10.5 43.5 10.5C45.5 10.5 47 12 47 14V30"
            stroke="#94A3B8"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          {/* Sparkles */}
          <path
            d="M26 22L28 17L30 22L35 24L30 26L28 31L26 26L21 24L26 22Z"
            fill="#A855F7"
          />
          <path
            d="M72 32L73.5 28.5L75 32L78.5 33.5L75 35L73.5 38.5L72 35L68.5 33.5L72 32Z"
            fill="#C084FC"
          />
          <path
            d="M28 66L29 63.5L30 66L32.5 67L30 68L29 70.5L28 68L25.5 67L28 66Z"
            fill="#C084FC"
          />

          <defs>
            <linearGradient
              id="frontDocGrad"
              x1="20"
              y1="18"
              x2="64"
              y2="76"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#9333EA" />
              <stop offset="1" stopColor="#7E22CE" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <p className="text-[13px] font-medium text-[#475467]">
        No documents attached
      </p>
    </div>
  );
};
